@if (callId !== null) {
<div class="fixed inset-0 z-[999] flex justify-end">
  <button type="button" class="absolute inset-0 bg-black/40" aria-label="Close" (click)="close()"></button>

  <aside class="relative z-10 h-full w-full max-w-md overflow-y-auto bg-white p-5 shadow-xl dark:bg-[#0e1726]">
    <div class="mb-4 flex items-start justify-between">
      <h5 class="text-lg font-semibold">LLM call details</h5>
      <button type="button" class="text-white-dark hover:text-danger" (click)="close()">✕</button>
    </div>

    @if (loading) {
    <div class="py-10 text-center text-white-dark">Loading…</div>
    } @else if (error) {
    <div class="rounded border border-danger/40 bg-danger-light p-3 text-danger">{{ error }}</div>
    } @else if (detail) {
    <dl class="space-y-3 text-sm">
      <div>
        <dt class="text-xs uppercase text-white-dark">Task</dt>
        <dd class="font-medium">{{ detail.task_code }}</dd>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <dt class="text-xs uppercase text-white-dark">Provider</dt>
          <dd>{{ detail.provider }}</dd>
        </div>
        <div>
          <dt class="text-xs uppercase text-white-dark">Model</dt>
          <dd>{{ detail.model?.display_name || detail.model_name }}</dd>
        </div>
      </div>
      @if (detail.model_version) {
      <div>
        <dt class="text-xs uppercase text-white-dark">Model version served</dt>
        <dd class="text-xs">{{ detail.model_version }}</dd>
      </div>
      }
      <div class="grid grid-cols-2 gap-3">
        <div>
          <dt class="text-xs uppercase text-white-dark">Tenant</dt>
          <dd>{{ detail.tenant?.tenant_name || detail.tenant_code || 'Unattributed' }}</dd>
        </div>
        <div>
          <dt class="text-xs uppercase text-white-dark">PD link</dt>
          <dd class="break-all text-xs">{{ detail.session_code || '—' }}</dd>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <dt class="text-xs uppercase text-white-dark">Timestamp</dt>
          <dd>{{ detail.request_timestamp | date : 'dd MMM yy HH:mm:ss' }}</dd>
        </div>
        <div>
          <dt class="text-xs uppercase text-white-dark">Duration</dt>
          <dd>{{ detail.processing_time_ms !== null ? detail.processing_time_ms + ' ms' : '—' }}</dd>
        </div>
      </div>

      <div class="border-t border-white-light pt-3 dark:border-[#1b2e4b]">
        <div class="mb-2 text-xs font-semibold uppercase text-white-dark">Token usage</div>
        <div class="space-y-1">
          <div class="flex justify-between"><span>Input</span><span>{{ detail.input_tokens ?? '—' }}</span></div>
          <div class="flex justify-between"><span>Output</span><span>{{ detail.output_tokens ?? '—' }}</span></div>
          <!-- Null, not zero: the provider did not report this metric, which is not the same
               as none having been used. -->
          <div class="flex justify-between">
            <span>Cached</span><span>{{ detail.cached_tokens ?? 'not reported' }}</span>
          </div>
          <div class="flex justify-between">
            <span>Reasoning</span><span>{{ detail.reasoning_tokens ?? 'not reported' }}</span>
          </div>
          <div class="flex justify-between font-semibold"><span>Total</span><span>{{ detail.total_tokens ?? '—' }}</span></div>
        </div>
      </div>

      <div class="border-t border-white-light pt-3 dark:border-[#1b2e4b]">
        <div class="mb-2 text-xs font-semibold uppercase text-white-dark">Cost</div>
        <div class="space-y-1">
          <div class="flex justify-between"><span>Input</span><span>{{ formatUsd(detail.input_cost_usd) }}</span></div>
          <div class="flex justify-between"><span>Output</span><span>{{ formatUsd(detail.output_cost_usd) }}</span></div>
          <div class="flex justify-between"><span>Cached</span><span>{{ formatUsd(detail.cached_cost_usd) }}</span></div>
          <div class="flex justify-between font-semibold">
            <span>Total</span><span>{{ formatUsd(detail.total_cost_usd) }}</span>
          </div>
          @if (detail.total_cost_inr) {
          <div class="flex justify-between text-xs text-white-dark">
            <span>In INR (rate {{ detail.fx_rate_usd_inr }})</span><span>₹{{ detail.total_cost_inr }}</span>
          </div>
          }
        </div>
        @if (!detail.cost_is_priced) {
        <div class="mt-2 rounded bg-warning-light p-2 text-xs text-warning">
          No price list covered this model when the call was made. The tokens are real; the cost is not known.
        </div>
        }
      </div>

      <div class="border-t border-white-light pt-3 dark:border-[#1b2e4b]">
        <dt class="text-xs uppercase text-white-dark">Status</dt>
        <dd class="mt-1">
          <span [class]="statusClass(detail.status)">{{ detail.status }}</span>
          @if (detail.attempt > 1) {
          <span class="ml-1 text-xs text-white-dark">attempt {{ detail.attempt }}</span>
          }
        </dd>
        @if (statusNote) {
        <div class="mt-2 rounded bg-warning-light p-2 text-xs text-warning">{{ statusNote }}</div>
        } @if (detail.error_code) {
        <div class="mt-2 rounded bg-danger-light p-2 text-xs text-danger">
          {{ detail.error_code }}<span *ngIf="detail.error_message">: {{ detail.error_message }}</span>
        </div>
        }
      </div>
    </dl>
    }
  </aside>
</div>
}
